import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useProAuth } from '@/lib/auth-context';

export function RequireApprovedPro({ children }: { children: ReactNode }) {
  const { user, proCustomer, isLoading, isProCustomerLoading } = useProAuth();
  const location = useLocation();

  // `isProCustomerLoading` compte comme un chargement : sans lui, le rendu
  // qui suit `setUser()` voyait `proCustomer === null` et renvoyait un
  // électricien approuvé sur « Approbation en attente » avant de le ramener
  // au tableau de bord — le clignotement signalé à chaque connexion.
  if (isLoading || isProCustomerLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--pro-bg)' }}>
        <div className="animate-pulse text-neutral-400">Chargement…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!proCustomer) {
    return <Navigate to="/pending-approval" replace />;
  }

  if (proCustomer.status !== 'approved') {
    return <Navigate to="/pending-approval" replace />;
  }

  return <>{children}</>;
}
